(function (window) {
  'use strict';

  var shopCurrency = window.shop_currency || 'TRY';

  var countryByCurrency = {
    TRY: 'TR',
    SAR: 'SA',
    AED: 'AE',
    KWD: 'KW',
    QAR: 'QA',
    BHD: 'BH',
    OMR: 'OM',
    USD: 'US',
    EUR: 'DE',
    GBP: 'GB'
  };

  var priceSelectors = [
    '.price-product .price',
    '.price-product .price-old',
    '.price-product s',
    '.product-price .enj-product-price',
    '.product-price .enj-product-price-compare',
    '.product-price ins',
    '.product-price del',
    '.engoj_price_main',
    '.enj-product-price',
    '.enj-product-price-compare',
    '.js-price',
    '.sticky_addcart .enj-product-price',
    '.sticky_addcart .enj-product-price-compare'
  ].join(',');

  function parseMoneyToCents(html) {
    if (!html) return 0;
    var text = String(html).replace(/[^\d.,]/g, '').trim();
    if (!text) return 0;

    if (text.indexOf(',') !== -1 && text.indexOf('.') !== -1) {
      text = text.replace(/,/g, '');
    } else if (text.indexOf(',') !== -1) {
      text = text.replace(',', '.');
    }

    return Math.round((parseFloat(text) || 0) * 100);
  }

  function formatCents(cents, currencyCode) {
    if (!window.Currency || !Currency.formatMoney) {
      return window.Shopify ? Shopify.formatMoney(cents, window.money_format) : '';
    }
    var code = currencyCode || shopCurrency;
    var formatKey = Currency.format || 'money_with_currency_format';
    var format = (Currency.moneyFormats[code] && Currency.moneyFormats[code][formatKey])
      || (Currency.moneyFormats[code] && Currency.moneyFormats[code].money_with_currency_format)
      || '{{amount}}';
    return Currency.formatMoney(cents, format);
  }

  function getSelectedCurrency() {
    if (!window.jQuery) return shopCurrency;
    var val = window.jQuery('[name=currencies]').first().val();
    return val || (window.Currency && window.Currency.currentCurrency) || shopCurrency;
  }

  function convertElement($el, from, target) {
    var cents = parseInt($el.attr('data-amount-cents'), 10);

    if (!cents || isNaN(cents)) {
      var baseHtml = $el.attr('data-currency-' + from) || $el.html();
      $el.attr('data-currency-' + from, baseHtml);
      cents = parseMoneyToCents(baseHtml);
      $el.attr('data-amount-cents', cents);
    }

    if (!cents) return;

    if (from === target) {
      var original = $el.attr('data-currency-' + from);
      if (original) $el.html(original);
      $el.attr('data-currency', from);
      return;
    }

    var convertedCents = window.Currency.convert(cents, from, target);
    var html = formatCents(convertedCents, target);
    $el.html(html);
    $el.attr('data-currency-' + target, html);
    $el.attr('data-currency', target);
  }

  function convertAllMoneyElements(target) {
    if (!window.jQuery || !window.Currency) return;
    var $ = window.jQuery;
    var from = shopCurrency;

    $(priceSelectors).add('.money').each(function () {
      convertElement($(this), from, target);
    });

    Currency.currentCurrency = target;
    if (Currency.cookie && Currency.cookie.write) {
      Currency.cookie.write(target);
    }
    $('.selected-currency').text(target);
  }

  function registerPrices($) {
    $(priceSelectors).add('.money').each(function () {
      var $el = $(this);
      $el.addClass('money');

      if (!$el.attr('data-currency-' + shopCurrency) && $el.html()) {
        $el.attr('data-currency-' + shopCurrency, $el.html());
      }

      if (!$el.attr('data-amount-cents')) {
        var cents = parseInt($el.attr('data-amount-cents'), 10);
        if (!cents || isNaN(cents)) {
          $el.attr('data-amount-cents', parseMoneyToCents($el.attr('data-currency-' + shopCurrency) || $el.html()));
        }
      }
    });
  }

  function updatePriceEl($el, cents) {
    if (!$el || !$el.length || cents == null) return;
    $el.addClass('money');
    $el.attr('data-amount-cents', cents);
    var html = formatCents(cents, shopCurrency);
    $el.html(html);
    $el.attr('data-currency-' + shopCurrency, html);
    $el.removeAttr('data-currency');
  }

  function setVariantPrices(variant) {
    if (!variant || !window.jQuery) return;
    var $ = window.jQuery;

    $('.enj-product-price').each(function () {
      updatePriceEl($(this), variant.price);
    });

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      $('.enj-product-price-compare').each(function () {
        updatePriceEl($(this), variant.compare_at_price);
      });
    } else {
      $('.enj-product-price-compare').html('');
    }

    convertAllMoneyElements(getSelectedCurrency());
  }

  function syncMarketCountry(currencyCode, reload) {
    var country = countryByCurrency[currencyCode];
    if (!country) return;

    var form = document.getElementById('TurkwayMarketForm');
    if (!form) return;

    var countryInput = form.querySelector('[name="country_code"]');
    if (!countryInput) return;
    if (countryInput.value === country && !reload) return;

    countryInput.value = country;

    if (window.fetch) {
      var data = new FormData(form);
      fetch(form.action, { method: 'POST', body: data, credentials: 'same-origin' })
        .then(function () {
          if (reload) window.location.reload();
        })
        .catch(function () {});
    }
  }

  function onCurrencyChange(currencyCode) {
    if (!window.jQuery) return;
    var $ = window.jQuery;

    $('[name=currencies]').val(currencyCode);
    registerPrices($);
    convertAllMoneyElements(currencyCode);
    syncMarketCountry(currencyCode, false);
  }

  function bindPicker($) {
    $('[name=currencies]').off('change.turkway').on('change.turkway', function () {
      onCurrencyChange($(this).val());
    });
  }

  function init($) {
    registerPrices($);
    bindPicker($);

    var cookieCurrency = window.Currency && Currency.cookie ? Currency.cookie.read() : null;
    var selected = cookieCurrency || getSelectedCurrency();
    $('[name=currencies]').val(selected);

    convertAllMoneyElements(selected);
    syncMarketCountry(selected, false);
  }

  window.TurkwayCurrency = {
    shopCurrency: shopCurrency,
    registerPrices: registerPrices,
    convertDisplayedPrices: function () {
      convertAllMoneyElements(getSelectedCurrency());
    },
    setVariantPrices: setVariantPrices,
    onCurrencyChange: onCurrencyChange,
    init: init
  };
})(window);
